import React from 'react';
import { Provider } from 'react-redux';
import { store } from './index';

interface Props {
  children: React.ReactNode;
}

function StoreProvider({ children }: Props): JSX.Element {
  return <Provider store={store}>{children}</Provider>;
}

export default StoreProvider;
